import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import ui from './modules/ui'
import request from './modules/request'
import org from './modules/org'
import blog from './modules/blog'
import claims from './modules/claims'
import hrcv from './modules/hrcv'
import orgsi from './modules/orgsi'
import agreements from './modules/agreements'
import mgr from './modules/mgr'
import tests from './modules/tests'
import events from './modules/receptures'
import calculations from './modules/calculations'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    auth,
    ui,
    request,
    org,
    blog,
    claims,
    hrcv,
    orgsi,
    agreements,
    mgr,
    tests,
    events,
    calculations
  },
  strict: debug
})
